<div class="bar card">
  <div class="progress" [style.width]="{ width: (100 * currentAmt) / maxAmt + '%' }">
    <div class="progress-label"> {{ ((100 * currentAmt) / maxAmt).toFixed(0) + '%' }} of {{ label }} </div>
  </div>
</div>
